import React from "react"
import { Card, CardBody, CardTitle, Row } from "reactstrap"
import DoctorRatingDonut from "./DoctorRatingDonut"
import { useSelector } from "react-redux"
import "../../newcomponents/index.css"

const MostRatedDoctorCard = ({ doctor }) => {
  const mode = useSelector(state => state.Layout.layoutMode)
  if (!doctor) return null
  return (
    <Card
      style={{
        borderRadius: "20px",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CardBody style={{ display: "flex", flexDirection: "column" }}>
        <CardTitle
          className={
            mode === "dark" ? "h4 mb-4 dark-text" : "h4 mb-4 light-text"
          }
        >
          Most Rated Doctor
        </CardTitle>

        <Row
          className={`text-center mt-4 ${mode === "dark" ? "dark-text" : "light-text"}`}
          style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center" }}
        >
          <div className="col-12">
            <img
              src={doctor.doctorAvatar}
              alt={doctor.doctorName}
              style={{
                width: "100px",
                height: "100px",
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
            <h5 className="font-size-18 mt-3">{doctor.doctorName}</h5>
            <p
              className={`text-muted ${mode === "dark" ? "dark-subText" : "light-subText"}`}
            >
              {doctor.doctorSpeciality}
            </p>
          </div>

          <div className="col-12 mt-3">
            <DoctorRatingDonut doctor={doctor} />
          </div>
        </Row>
      </CardBody>
    </Card>
  )
}

export default MostRatedDoctorCard